import { createIcon } from './createIcon';

/** Keycap "/" — opens the slash-command menu from the composer. */
export const SlashIcon = createIcon({
  name: 'SlashIcon',
  viewBox: '0 0 17 17',
  size: 14,
  children: (
    <>
      <rect
        x="0.5"
        y="0.5"
        width="16"
        height="16"
        rx="4"
        stroke="currentColor"
      />
      <path
        d="M10.7148 3.86816L7.39258 13.1318H6.28516L9.61328 3.86816H10.7148Z"
        fill="currentColor"
      />
    </>
  ),
});

export default SlashIcon;
